import React, { useState } from "react";
import {
  markCategoryFeatured,
  markCategoryUnFeatured,
} from "../../../services/categoryService";
import Swal from "sweetalert2";
import { handleErrors } from "../../../utils/errorHandler";

const CategoryFeaturedToggleSwitch = ({
  propId,
  initialStatus,
  onStatusChange,
}) => {
  const [isFeatured, setisFeatured] = useState(initialStatus === "Featured");

  const handleToggle = async () => {
    const newStatus = isFeatured ? "UnFeatured" : "Featured";
    const modalTitle = isFeatured
      ? "Mark Category UnFeatured"
      : "Mark Category Featured";
    const modalMessage = isFeatured
      ? "Are you sure you want to mark this category unfeatured?"
      : "Are you sure you want to mark this category featured?";

    const result = await Swal.fire({
      title: modalTitle,
      text: modalMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        if (isFeatured) {
          await markCategoryUnFeatured(propId, newStatus);
        } else {
          await markCategoryFeatured(propId, newStatus);
        }
        setisFeatured(!isFeatured);
        onStatusChange(newStatus);

        Swal.fire(
          "Success!",
          `The category has been ${
            newStatus === "Featured" ? "Featured" : "UnFeatured"
          }.`,
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <label className="switch">
      <div className="form-check form-switch form-switch-custom form-switch-primary">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isFeatured} // Checked means user is Blocked
          onChange={handleToggle}
        />
      </div>
      <span className="slider round"></span>
    </label>
  );
};

export default CategoryFeaturedToggleSwitch;
